import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Mail } from "lucide-react";
import { Logo } from "@/components/site/Logo";

const EMAIL = "ciao@getmimis.com";

const TikTok = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
    <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 1 1-2.59-2.6c.27 0 .53.04.77.12V9.77a5.7 5.7 0 0 0-.77-.05A5.68 5.68 0 1 0 15.54 15.4V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3a4.3 4.3 0 0 1-3.24-1.48Z" />
  </svg>
);

const SOCIAL = [
  { icon: Instagram, label: "Instagram", id: "instagram" },
  { icon: TikTok, label: "TikTok", id: "tiktok" },
  { icon: Facebook, label: "Facebook", id: "facebook" },
  { icon: Youtube, label: "YouTube", id: "youtube" },
];

export const Footer = () => {
  return (
    <footer className="relative overflow-hidden bg-[#F5F5F7]" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 pb-10 pt-20 sm:px-8">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo size="h-9" />
            <p className="mt-5 max-w-sm text-[0.95rem] leading-relaxed text-[#52525b]">
              Mr & Ms — l'Hub di App che Risolvono Problemi Veri. Si parte dall'Italia, poi il mondo.
            </p>
            <div className="mt-6 flex gap-2.5">
              {SOCIAL.map(({ icon: Icon, label, id }) => (
                <a key={id} href="#" aria-label={label} className="grid h-11 w-11 place-items-center rounded-full border border-[#e2e2e6] bg-white text-[#111111] transition-[transform,background-color,color] duration-300 hover:-translate-y-1 hover:bg-[#0066FF] hover:text-white" data-testid={`footer-social-${id}`}>
                  <Icon className="h-[18px] w-[18px]" />
                </a>
              ))}
            </div>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs font-semibold uppercase tracking-[0.14em] text-[#52525b]">Prodotto</p>
            <ul className="mt-4 space-y-3 text-[0.95rem]">
              <li><Link to="/tool/mimis-video" className="nav-link" data-testid="footer-tool-link">MIMIS Video Italia</Link></li>
              <li><Link to="/tool/mimis-video#prezzo" className="nav-link" data-testid="footer-prices-link">Prezzi</Link></li>
              <li><Link to="/tool/mimis-video" className="nav-link" data-testid="footer-try-link">Prova MIMIS Video</Link></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="text-xs font-semibold uppercase tracking-[0.14em] text-[#52525b]">Contatti</p>
            <a href={`mailto:${EMAIL}`} className="mt-4 inline-flex items-center gap-2 text-[0.95rem] font-medium text-[#111111] hover:text-[#0066FF]" data-testid="footer-email-link">
              <Mail className="h-4 w-4" /> {EMAIL}
            </a>
            <p className="mt-3 text-[0.95rem] text-[#52525b]">Fatto in Italia da Franco & Daniel.</p>
          </div>
        </div>
        <p className="font-display mt-16 select-none text-[10.5vw] font-extrabold leading-[0.9] tracking-tighter text-[#111111] lg:text-[8.5rem]" data-testid="footer-domain">
          getmimis<span className="text-[#0066FF]">.com</span>
        </p>
        <div className="mt-8 flex flex-col justify-between gap-3 border-t border-[#e2e2e6] pt-6 text-sm text-[#52525b] sm:flex-row">
          <span>© {new Date().getFullYear()} MIMIS · Mr & Ms. Tutti i diritti riservati.</span>
          <span>getmimis.com</span>
        </div>
      </div>
    </footer>
  );
};
